import { Link, useNavigate } from "react-router-dom"
import FavButton from "../../Elements/Buttons/FavButton"
import Image from "../../Elements/Image/Image"
import OrganizationCost from "../../Elements/OrganizationCost/OrganizationCost"
import LocationImp from '../../../../Assets/icons/location.svg'
import { useSelector } from "react-redux"
import axios from "axios"
import { WISHLISTS } from "../../../../Utilities/APIs"

function OrganizationCard({organization, triggerFetch}) {

    // console.log(organization)

    const navigate = useNavigate()
    const {consumer} = useSelector(state => state.auth)
    
    async function handleClick() {

        if (consumer) {

            const config = {
                headers: {
                    Authorization: `Bearer ${consumer.token}`
                }
            }

            if (organization.favorite === true) {
                await axios.delete(WISHLISTS + organization._id, config)
            } else {
                await axios.post(WISHLISTS, {organization: organization._id}, config)
            }

            triggerFetch()

        } else {
            navigate('/login')
        }
        
    }

    return (
        <div className="col">
            <div className="org_card">
                <div className='image_grdient'>
                    <Link to={`/organization-details/${organization._id}`} target='_blank'>
                        <Image imgSrc={organization.cardImage} imgAlt={organization.name} />
                    </Link>
                    <FavButton favorite={organization.favorite} handleClick={handleClick}/>
                </div>
                <div className="card_body">
                    <h3>
                        {
                            consumer
                            ?
                                consumer.language === 'english'
                                ?
                                    organization.engName
                                :
                                    organization.name
                            :
                                organization.name
                        }
                    </h3>
                    <div className='expense'>
                        <OrganizationCost cost={organization.cost} />
                    </div>
                    <div className="details_box">
                        <div>
                            <span>
                                <img src={LocationImp} alt="" />
                                ঢাকা
                            </span>
                        </div>
                        <div>
                            <Link to={`/organization-details/${organization._id}`} className='view_details'>
                            {
                                consumer
                                ?
                                    consumer.language === 'english'
                                    ?
                                        'View Details'
                                    :
                                        'আরো দেখুন'
                                :
                                    'আরো দেখুন'
                            }
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrganizationCard